import "./fcopel/style.css";
import { Sectionpd} from "../componentes/padroes";
import { Sectioninterna, Btnnav, Desctablet, Paragrafoint, Navcommand, Tags, Flexmidbanner, InternoBanner } from "./padroespages";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

function Elosprev() {
  return (
    <main>
        <Helmet>
            <title>Elosprev - Gabriel Barbosa</title>
            <meta name="description" content="Desdobramento do Site principal da EnergisaPrev, dispondo das informações do relatório anual de investimentos do fundo previdenciário privado destinado aos associados do grupo Energisa, holding brasileira de distribuição de energia." />
        </Helmet>
        <InternoBanner style={{ backgroundImage: 'url(/img/clientes/bannerelosprev.jpg'}}>
            <div className="container z-2">
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="descbannerint">
                            <h1>ELOSPREV</h1>
                            <Flexmidbanner>
                                <a href="https://elos.org.br/" target="_blank" rel="noreferrer">elos.org.br/elosprev</a>
                                <span>VIA CRT COMUNICAÇÃO</span>
                            </Flexmidbanner>
                            <Tags>//FRONT-END + RESTRUTURAÇÃO UX/UI</Tags>
                            <Paragrafoint>Site criado para fundação previdenciária destinada à colaboradores da Eletrosul Centrais Elétricas (atual Eletrobras CGT Eletrosul) - concessionária de distribuição de energia elétrica na Região Sul e MS, e a A Engie (antiga GDF SUEZ) - o segundo maior grupo do ramo de energia no mundo.</Paragrafoint>  
                        </div>
                    </div>
                </div>
            </div>
        </InternoBanner>
        <Sectioninterna>
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12">
                        <div className="destaque-image">
                            <div className="mockup-container">
                                <img src="/img/clientes/tablet.png" className="tablet-mockup" alt="Tablet" />

                                <div className="site-preview">
                                    <img src="/img/clientes/elosprevfull.png" alt="ELOSPREV" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8">
                        <Desctablet>Auxiliando no processo de reestruturação UI do site, com o objetivo de aprimorar a experiência do usuário e modernizar a interface, a reformulação incluiu a criação de um novo design para a página inicial e para as páginas internas, proporcionando um visual mais intuitivo e agradável usando JavaScript para sua execução. </Desctablet>
                    </div>
                </div>
            </div>
        </Sectioninterna>

        <Sectioninterna>
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12">
                        <div className="destaque-image">
                            <div className="mockup-container">
                                <img src="/img/clientes/tablet.png" className="tablet-mockup" alt="Tablet" />

                                <div className="site-preview">
                                    <img src="/img/clientes/elosprevfull.png" alt="ELOSPREV" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8">
                        <Desctablet>Além disso, realizei a reestruturação do mecanismo de busca com PHP, implementando uma versão mais avançada e precisa, com foco em melhorar a eficiência e a relevância dos resultados. Também fui encarregado de corrigir e otimizar os formulários de contato e a integração com o CRM, também fazendo uso de PHP para garantir uma gestão mais eficiente e organizada das informações dos usuários.</Desctablet>
                    </div>
                </div>
            </div>
        </Sectioninterna>
        <Sectionpd>
            <div className="container">
                <div className="row">
                    <div className="col-6 order-1 order-lg-0 col-lg-5 align-content-lg-center col-5 justify-content-lg-end text-lg-end">
                        <Link to="/prestador" style={{ textDecoration: 'none' }}>
                            <Btnnav>
                                <span>//ANTERIOR</span>
                                <h3>COPEL Prestador</h3>
                                <span>//FRONT-END + INTEGRAÇÃO + WORDPRESS</span>
                            </Btnnav>
                        </Link>
                    </div>
                    <div className="col-12 order-0 col-lg-2 order-lg-1">
                        <Navcommand>
                            <Link to="/prestador" style={{ textDecoration: 'none' }}></Link>
                            <span></span>
                            <Link to="/fundaffemg" style={{ textDecoration: 'none' }}></Link>
                        </Navcommand>
                    </div>
                    <div className="col-6 order-2 col-lg-5 order-lg-2 align-content-lg-center col-5 justify-content-lg-end">
                        <Link to="/fundaffemg" style={{ textDecoration: 'none' }}>
                            <Btnnav>
                                <span>//PRÓXIMO</span>
                                <h3>FUNDAFFEMG</h3>
                                <span>//FRONT-END + INTEGRAÇÃO + WORDPRESS + HOSPEDAGEM</span>
                            </Btnnav>
                        </Link> 
                    </div>
                </div>
            </div>
        </Sectionpd>
    </main>
  );
}

export default Elosprev;